import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PDV() {
  const navigate = useNavigate();

  const accesos = [
    { label: 'Inventario',  sub: 'Diario y semanal',      icon: '📦', path: '/inventario', color: '#EFF6FF', border: '#BFDBFE' },
    { label: 'Helados',     sub: 'Sabores y bandejas',     icon: '🍨', path: '/helados',    color: '#FCE4EC', border: '#F8BBD0' },
    { label: 'Control caja',sub: 'Cierre del día',         icon: '💰', path: '/caja',       color: '#F0FDF4', border: '#BBF7D0' },
    { label: 'Sobres',      sub: 'Consignaciones',         icon: '🏦', path: '/sobres',     color: '#FEF3C7', border: '#FDE68A' },
  ];

  return (
    <div>
      <h1 style={{ margin: '0 0 16px', fontSize: 20, fontWeight: 800, color: '#111827' }}>🏪 Punto de venta</h1>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {accesos.map((a) => (
          <button key={a.path} onClick={() => navigate(a.path)}
            style={{ padding: 16, background: a.color, border: `2px solid ${a.border}`, borderRadius: 14, cursor: 'pointer', textAlign: 'left' }}>
            <div style={{ fontSize: 24, marginBottom: 6 }}>{a.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{a.label}</div>
            <div style={{ fontSize: 11, color: '#6B7280', marginTop: 2 }}>{a.sub}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
